export default {
    injuryDateFields: ['injuryDate', 'returnDate']
}